/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { OWLogCategory } from './OWLogCategory';
import {
    OWLogCategoryFromJSON,
    OWLogCategoryFromJSONTyped,
    OWLogCategoryToJSON,
    OWLogCategoryToJSONTyped,
} from './OWLogCategory';

/**
 * 
 * @export
 * @interface OWEvent
 */
export interface OWEvent {
    /**
     * Object containing event information.
     * @type {object}
     * @memberof OWEvent
     */
    data: object;
    /**
     * The ID of the game for which the event is being logged.
     * @type {string}
     * @memberof OWEvent
     */
    gameId: string;
    /**
     * The title of the game for which the event is being logged.
     * @type {string}
     * @memberof OWEvent
     */
    gameTitle: string;
    /**
     * The ID of the user who triggered the event.
     * @type {string}
     * @memberof OWEvent
     */
    userId: string;
    /**
     * The timestamp when the event occurred, in ISO 8601 format (generated using Date.now()).
     * @type {number}
     * @memberof OWEvent
     */
    timestamp: number;
    /**
     * 
     * @type {OWLogCategory}
     * @memberof OWEvent
     */
    category: OWLogCategory;
}



/**
 * Check if a given object implements the OWEvent interface.
 */
export function instanceOfOWEvent(value: object): value is OWEvent {
    if (!('data' in value) || value['data'] === undefined) return false;
    if (!('gameId' in value) || value['gameId'] === undefined) return false;
    if (!('gameTitle' in value) || value['gameTitle'] === undefined) return false;
    if (!('userId' in value) || value['userId'] === undefined) return false;
    if (!('timestamp' in value) || value['timestamp'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    return true;
}

export function OWEventFromJSON(json: any): OWEvent {
    return OWEventFromJSONTyped(json, false);
}

export function OWEventFromJSONTyped(json: any, ignoreDiscriminator: boolean): OWEvent {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'],
        'gameId': json['gameId'],
        'gameTitle': json['gameTitle'],
        'userId': json['userId'],
        'timestamp': json['timestamp'],
        'category': OWLogCategoryFromJSON(json['category']),
    };
}

export function OWEventToJSON(json: any): OWEvent {
    return OWEventToJSONTyped(json, false);
}

export function OWEventToJSONTyped(value?: OWEvent | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'data': value['data'],
        'gameId': value['gameId'],
        'gameTitle': value['gameTitle'],
        'userId': value['userId'],
        'timestamp': value['timestamp'],
        'category': OWLogCategoryToJSON(value['category']),
    };
}

